import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider  } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBBDifxRMiAPdNE0bw74Dy-zCTw01zYx_c",
  authDomain: "iwcz-55d8f.firebaseapp.com",
  projectId: "iwcz-55d8f",
  storageBucket: "iwcz-55d8f.firebasestorage.app",
  messagingSenderId: "893688806782",
  appId: "1:893688806782:web:a761f1365962c08363472f",
  measurementId: "G-4QXH766DX7"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
